import { IPartialTheme, IStyleSet } from "@fluentui/react/lib/Styling"
import { IStyleFunctionOrObject } from "@fluentui/react/lib/Utilities"

import { IVisualizationStyles } from "./Visualization.types"

export const VisualizationStyles: IStyleFunctionOrObject<
    IPartialTheme,
    IStyleSet<IVisualizationStyles>
> = () => ({
    root: { height: "100%" },
    visualEditor: {},
    visualEditorDiv: { height: "100%", width: "100%" }
})
